import React, { useEffect, useState } from 'react';
import { Button } from './ui';
const NAV_LINKS: {
  label: string;
  href: string;
}[] = [{
  label: 'Homes',
  href: '#top'
}, {
  label: 'Display Homes',
  href: '#latitude'
}, {
  label: 'Completed Homes',
  href: '#completed-homes'
}, {
  label: 'Awards',
  href: '#awards'
}, {
  label: 'Our Team',
  href: '#team'
}, {
  label: 'House & Land',
  href: '#enquire'
}, {
  label: 'Contact',
  href: '#enquire'
}];
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll while the mobile menu is open + close on Escape.
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-600 ${scrolled ? 'bg-atrium-ivory/95 backdrop-blur-md py-4' : 'bg-atrium-ivory/80 py-6'}`} aria-label="Primary" data-id="element-56">
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-atrium-stone opacity-30" data-id="element-57" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between" data-id="element-58">
        {/* Logo */}
        <a href="#top" className="flex flex-col items-start group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atrium-bronze/60 focus-visible:ring-offset-4 focus-visible:ring-offset-atrium-ivory rounded-sm" aria-label="Atrium Homes, back to top" data-id="element-59">
          {/* <!-- real logo SVG to swap = appsplugins/atrium-homes.svg (green #005941) --> */}
          <span className="font-serif text-2xl tracking-[0.1em] text-atrium-green uppercase leading-none" data-id="element-60">
            Atrium
          </span>
          <span className="font-sans text-[0.65rem] tracking-[0.2em] text-atrium-ink uppercase mt-1 ml-0.5" data-id="element-61">
            Homes
          </span>
        </a>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center space-x-8" data-id="element-62">
          {NAV_LINKS.map(link => <a key={link.label} href={link.href} className="text-sm font-medium text-atrium-ink hover:text-atrium-green transition-colors duration-300 relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[1px] after:bg-atrium-bronze after:transition-transform after:duration-600 after:scale-x-0 hover:after:scale-x-100 after:origin-left" data-id="element-63">
              {link.label}
            </a>)}
        </div>

        {/* Right Actions (desktop) */}
        <div className="hidden md:flex items-center space-x-6" data-id="element-64">
          <a href="tel:+61863108888" className="text-sm font-medium text-atrium-ink hover:text-atrium-green transition-colors" data-id="element-65">
            (08) 6310 8888
          </a>
          <Button variant="nav" as="a" href="#enquire" data-id="element-66">
            Book a Consultation
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-atrium-ink p-2 -mr-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atrium-bronze/60 rounded-sm" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} aria-controls="mobile-menu" onClick={() => setMenuOpen(v => !v)} data-id="element-67">
          {menuOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" data-id="element-68">
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" strokeLinejoin="round" data-id="element-69" />
            </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" data-id="element-70">
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" strokeLinejoin="round" data-id="element-71" />
            </svg>}
        </button>
      </div>

      {/* Mobile Drawer */}
      <div id="mobile-menu" className={`lg:hidden fixed inset-x-0 top-0 z-40 bg-atrium-ivory transition-transform duration-600 ease-editorial ${menuOpen ? 'translate-y-0' : '-translate-y-full pointer-events-none'}`} style={{
      minHeight: '100vh'
    }} aria-hidden={!menuOpen} data-id="element-72">
        <div className="pt-28 pb-12 px-6 flex flex-col h-full" data-id="element-73">
          <div className="flex flex-col divide-y divide-atrium-stone/40 border-t border-atrium-stone/40" data-id="element-74">
            {NAV_LINKS.map(link => <a key={link.label} href={link.href} onClick={() => setMenuOpen(false)} className="py-5 font-serif text-2xl text-atrium-ink hover:text-atrium-green transition-colors" data-id="element-75">
                {link.label}
              </a>)}
          </div>

          <div className="mt-auto pt-10 space-y-4" data-id="element-76">
            <Button variant="primary" as="a" href="#enquire" className="w-full" onClick={() => setMenuOpen(false)} data-id="element-77">
              Book a Consultation
            </Button>
            <a href="tel:+61863108888" className="block text-center text-sm font-medium tracking-wide text-atrium-ink hover:text-atrium-green transition-colors py-2" data-id="element-78">
              Call (08) 6310 8888
            </a>
          </div>
        </div>
      </div>
    </nav>;
}